import axios from 'axios'
import { auth } from './firebase'

export const api = axios.create({
  baseURL: import.meta.env['VITE_API_URL'] ?? '',
  timeout: 15000,
})

export function getApiErrorMessage(err: unknown, fallback = 'Something went wrong. Please try again.'): string {
  if (axios.isAxiosError(err)) {
    const code: string = err.response?.data?.code ?? ''
    switch (code) {
      case 'INVALID_CODE':     return 'That code is incorrect or has expired.'
      case 'AUTH_UNAVAILABLE': return 'Sign-in is temporarily unavailable. Please try again.'
      case 'RATE_LIMITED':     return 'Too many attempts. Please wait a few minutes before trying again.'
    }
    const msg: string = err.response?.data?.error ?? ''
    if (msg) return msg
  }
  return fallback
}

api.interceptors.request.use(async config => {
  const user = auth?.currentUser
  if (user) {
    const token = await user.getIdToken()
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
